import { SEOHead } from "@/components/SEOHead";
import { HeaderNavigation } from "@/components/HeaderNavigation";
import { FooterSEO } from "@/components/FooterSEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { AUTHORS } from "@/data/authors";
import { Users, Phone, MessageSquare, Award, CheckCircle2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function TeamPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col justify-between">
      <SEOHead
        title="Ekibimiz & Danışmanlarımız | Corner Gayrimenkul Adana"
        description="Corner Gayrimenkul Adana gayrimenkul danışmanları kadrosu. Gürselpaşa, Seyhan ve Çukurova bölge uzmanları."
        canonicalPath="/ekibimiz"
      />
      <HeaderNavigation />

      <main className="flex-1 py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
        <Breadcrumbs items={[{ label: "Ekibimiz" }]} />

        <div className="mb-12 text-center max-w-3xl mx-auto">
          <span className="px-3 py-1 rounded-full bg-primary/10 text-primary font-bold text-xs uppercase tracking-wider">
            Uzman Kadro
          </span>
          <h1 className="text-3xl sm:text-5xl font-black text-foreground tracking-tight my-4">
            Corner Gayrimenkul Danışmanları
          </h1>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Adana gayrimenkul piyasasında saha tecrübesine sahip, etik ve dürüst danışmanlık sunan uzman kadromuz.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-8 max-w-4xl mx-auto">
          {[AUTHORS['gurkan-sonmez']].map((agent) => (
            <Card key={agent.id} className="p-8 bg-card border border-border rounded-3xl shadow-lg flex flex-col justify-between">
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <img
                    src={agent.image}
                    alt={agent.name}
                    className="w-20 h-20 rounded-full object-cover border-2 border-primary/30 shrink-0"
                  />
                  <div>
                    <h3 className="font-extrabold text-2xl text-foreground">{agent.name}</h3>
                    <p className="text-sm font-bold text-primary">{agent.title}</p>
                    <span className="text-xs text-muted-foreground">📍 Adana Seyhan & Çukurova</span>
                  </div>
                </div>

                <p className="text-sm text-muted-foreground leading-relaxed">
                  {agent.bio}
                </p>

                <div className="space-y-1.5 pt-2">
                  <span className="text-xs font-bold text-foreground block">Uzmanlık Alanları:</span>
                  <div className="flex flex-wrap gap-1.5">
                    {agent.expertiseAreas.map((area, i) => (
                      <span key={i} className="px-2.5 py-0.5 rounded bg-muted text-[11px] font-semibold text-foreground">
                        ✓ {area}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-border mt-6 flex flex-col sm:flex-row gap-3">
                <Button asChild size="sm" className="bg-green-600 hover:bg-green-700 font-bold flex-1">
                  <a href={`https://wa.me/${agent.whatsapp}`} target="_blank" rel="noreferrer">
                    <MessageSquare className="h-4 w-4 mr-1.5" /> WhatsApp
                  </a>
                </Button>
                <Button asChild variant="outline" size="sm" className="font-bold flex-1">
                  <Link to={`/danisman/${agent.slug}`}>
                    Profil & Portföyler
                  </Link>
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </main>

      <FooterSEO />
    </div>
  );
}
